import {Injectable} from '@angular/core';
import {BaseService} from '../../base.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends BaseService {
  listAction(query?: any) {
    const httpOptions = {
      params: query
    };
    return this.get<any>('/action-his', httpOptions);
  }

  listSupcription() {
    return this.get<any>('/subscription/stats');
  }

  charList(query?: any) {
    const httpOptions = {
      params: query
    };
    return this.get<any>('/customer/chart', httpOptions);
  }

  summary() {
    return this.get<any>('/customer/summary');

  }
}
